import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { EntityDialogDeactivateSource } from './entity.dialog.contracts';

/**
 * The half of the leave check that `beforeClose` cannot do.
 *
 * A dialog's own close path sees Cancel, Escape and a backdrop click. It never sees the URL changing
 * underneath it — a side-nav click, a browser Back, a link elsewhere in the app — because nothing asked
 * the dialog to close. Without this guard those silently discard a half-filled form.
 *
 * `true` means saved, empty, or explicitly discarded. `false` means stay: Angular cancels the navigation
 * and restores the URL, so the same dialog and URL remain.
 */
export const entityDialogRouteGuard: CanDeactivateFn<unknown> = () => {

  const source = inject(EntityDialogDeactivateSource);

  // An intentional teardown already ran the check; asking again would prompt twice for one exit.
  if (source.$deactivating()) return true;
  // A prompt is already open — the user clicked Cancel, then the side nav while the confirm was up.
  // Refuse rather than stack a second prompt over the first.
  if (source.$deactivatePending()) return false;

  return source.canDeactivateActive('navigate');
};
